var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 131,
    viewBox: "0 0 638 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.721 116.013C521.605 116.901 528.898 119.309 533.928 121.363C538.958 123.417 548.023 127.007 554.071 129.339C563.822 133.1 565.069 133.903 565.069 136.421C565.069 138.616 563.886 139.872 559.86 141.954C552.277 145.875 543.896 144.902 521.069 137.451C502.603 131.423 499.098 130.873 484.694 131.742C480.54 131.993 479.161 131.553 477.444 129.432C474.649 125.98 473.571 121.408 475.011 119.112C477.121 115.748 507.065 113.575 517.721 116.013Z",
    fill: "url(#paint0_linear_4903_18601)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M561.305 109.825L561.304 109.824C560.34 109.54 559.204 109.335 558.16 109.241C557.084 109.144 556.233 109.175 555.788 109.285C555.529 109.349 555.075 109.401 554.556 109.449C553.999 109.502 553.265 109.559 552.378 109.62C550.603 109.742 548.193 109.88 545.323 110.027C539.583 110.32 531.988 110.645 523.922 110.933C504.379 111.629 492.476 112.432 484.993 113.953C481.261 114.712 478.714 115.634 476.895 116.755C475.106 117.857 473.976 119.179 473.118 120.836C472.726 121.596 472.467 122.132 472.313 122.556C472.163 122.972 472.147 123.189 472.162 123.324C472.176 123.445 472.226 123.611 472.434 123.9C472.656 124.208 473 124.58 473.538 125.118C473.798 125.377 474.005 125.592 474.18 125.774C474.535 126.141 474.757 126.371 475.013 126.56C475.274 126.751 475.551 126.879 476.188 126.905C476.894 126.933 477.941 126.831 479.697 126.569C480.927 126.386 482.454 126.133 484.393 125.811C485.196 125.678 486.07 125.533 487.022 125.376C500.217 123.208 515.322 123.175 524.52 125.347C528.435 126.271 537.185 129.367 543.991 132.22L543.991 132.22C551.901 135.536 556.498 137.307 559.553 137.98C561.06 138.311 562.113 138.357 562.956 138.223C563.784 138.092 564.492 137.775 565.296 137.248L565.296 137.248C567.095 136.07 568.364 134.004 569.068 131.373C569.77 128.749 569.878 125.664 569.435 122.627C568.993 119.589 568.01 116.666 566.59 114.357C565.165 112.041 563.361 110.432 561.305 109.825Z",
    fill: "url(#paint1_linear_4903_18601)",
    stroke: "url(#paint2_linear_4903_18601)",
    strokeWidth: 2.31528
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M603.292 1.87221L603.292 1.87221C599.467 1.64512 591.97 1.7201 584.764 1.96967C577.516 2.2207 570.812 2.64078 568.496 3.06603C562.997 4.07595 558.618 6.93817 556.459 10.6186C555.134 12.8805 554.555 16.1108 554.256 26.106C554.044 33.1792 553.748 37.5599 552.326 42.5079C550.92 47.3999 548.428 52.7913 543.984 61.9474L543.984 61.9475C536.351 77.6729 532.925 94.7171 532.742 118.435C532.691 125.033 533.002 129.182 533.881 132.099C534.717 134.873 536.078 136.571 538.4 138.215C541.583 140.469 544.989 141.756 551.436 142.14C557.98 142.531 567.501 141.985 582.84 140.624C594.364 139.602 600.973 138.823 605.319 137.641C607.456 137.06 608.985 136.397 610.249 135.593C611.514 134.79 612.585 133.801 613.768 132.479L615.062 133.638L613.768 132.479C616.118 129.856 617.514 127.415 618.262 124.269C619.025 121.054 619.135 117.004 618.71 111.112C617.575 95.4059 617.003 87.0942 617.1 81.7303C617.199 76.2021 618.016 73.6798 619.551 69.6028L619.551 69.6024C621.109 65.47 624.788 56.7046 627.733 50.1068L627.734 50.1066C632.734 38.9084 635.388 31.3592 636.08 25.5297C636.754 19.8542 635.569 15.7976 632.664 11.4999C628.591 5.47642 622.133 2.98947 603.292 1.87221Z",
    fill: "url(#paint3_linear_4903_18601)",
    stroke: "url(#paint4_linear_4903_18601)",
    strokeWidth: 3.47292
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.721 116.013C426.605 116.901 433.898 119.309 438.928 121.363C443.958 123.417 453.023 127.007 459.071 129.339C468.822 133.1 470.069 133.903 470.069 136.421C470.069 138.616 468.886 139.872 464.86 141.954C457.277 145.875 448.896 144.902 426.069 137.451C407.603 131.423 404.098 130.873 389.694 131.742C385.54 131.993 384.161 131.553 382.444 129.432C379.649 125.98 378.571 121.408 380.011 119.112C382.121 115.748 412.065 113.575 422.721 116.013Z",
    fill: "url(#paint5_linear_4903_18601)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M466.305 109.825L466.304 109.824C465.34 109.54 464.204 109.335 463.16 109.241C462.084 109.144 461.233 109.175 460.788 109.285C460.529 109.349 460.075 109.401 459.556 109.449C458.999 109.502 458.265 109.559 457.378 109.62C455.603 109.742 453.193 109.88 450.323 110.027C444.583 110.32 436.988 110.645 428.922 110.933C409.379 111.629 397.476 112.432 389.993 113.953C386.261 114.712 383.714 115.634 381.895 116.755C380.106 117.857 378.976 119.179 378.118 120.836C377.726 121.596 377.467 122.132 377.313 122.556C377.163 122.972 377.147 123.189 377.162 123.324C377.176 123.445 377.226 123.611 377.434 123.9C377.656 124.208 378 124.58 378.538 125.118C378.798 125.377 379.005 125.592 379.18 125.774C379.535 126.141 379.757 126.371 380.013 126.56C380.274 126.751 380.551 126.879 381.188 126.905C381.894 126.933 382.941 126.831 384.697 126.569C385.927 126.386 387.454 126.133 389.393 125.811C390.196 125.678 391.07 125.533 392.022 125.376C405.217 123.208 420.322 123.175 429.52 125.347C433.435 126.271 442.185 129.367 448.991 132.22L448.991 132.22C456.901 135.536 461.498 137.307 464.553 137.98C466.06 138.311 467.113 138.357 467.956 138.223C468.784 138.092 469.492 137.775 470.296 137.248L470.296 137.248C472.095 136.07 473.364 134.004 474.068 131.373C474.77 128.749 474.878 125.664 474.435 122.627C473.993 119.589 473.01 116.666 471.59 114.357C470.165 112.041 468.361 110.432 466.305 109.825Z",
    fill: "url(#paint6_linear_4903_18601)",
    stroke: "url(#paint7_linear_4903_18601)",
    strokeWidth: 2.31528
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M508.292 1.87221L508.292 1.87221C504.467 1.64512 496.97 1.7201 489.764 1.96967C482.516 2.2207 475.812 2.64078 473.496 3.06603C467.997 4.07595 463.618 6.93817 461.459 10.6186C460.134 12.8805 459.555 16.1108 459.256 26.106C459.044 33.1792 458.748 37.5599 457.326 42.5079C455.92 47.3999 453.428 52.7913 448.984 61.9474L448.984 61.9475C441.351 77.6729 437.925 94.7171 437.742 118.435C437.691 125.033 438.002 129.182 438.881 132.099C439.717 134.873 441.078 136.571 443.4 138.215C446.583 140.469 449.989 141.756 456.436 142.14C462.98 142.531 472.501 141.985 487.84 140.624C499.364 139.602 505.973 138.823 510.319 137.641C512.456 137.06 513.985 136.397 515.249 135.593C516.514 134.79 517.585 133.801 518.768 132.479L520.062 133.638L518.768 132.479C521.118 129.856 522.514 127.415 523.262 124.269C524.025 121.054 524.135 117.004 523.71 111.112C522.575 95.4059 522.003 87.0942 522.1 81.7303C522.199 76.2021 523.016 73.6798 524.551 69.6028L524.551 69.6024C526.109 65.47 529.788 56.7046 532.733 50.1068L532.734 50.1066C537.734 38.9084 540.388 31.3592 541.08 25.5297C541.754 19.8542 540.569 15.7976 537.664 11.4999C533.591 5.47642 527.133 2.98947 508.292 1.87221Z",
    fill: "url(#paint8_linear_4903_18601)",
    stroke: "url(#paint9_linear_4903_18601)",
    strokeWidth: 3.47292
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.721 116.013C332.605 116.901 339.898 119.309 344.928 121.363C349.958 123.417 359.023 127.007 365.071 129.339C374.822 133.1 376.069 133.903 376.069 136.421C376.069 138.616 374.886 139.872 370.86 141.954C363.277 145.875 354.896 144.902 332.069 137.451C313.603 131.423 310.098 130.873 295.694 131.742C291.54 131.993 290.161 131.553 288.444 129.432C285.649 125.98 284.571 121.408 286.011 119.112C288.121 115.748 318.065 113.575 328.721 116.013Z",
    fill: "url(#paint10_linear_4903_18601)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M372.305 109.825L372.304 109.824C371.34 109.54 370.204 109.335 369.16 109.241C368.084 109.144 367.233 109.175 366.788 109.285C366.529 109.349 366.075 109.401 365.556 109.449C364.999 109.502 364.265 109.559 363.378 109.62C361.603 109.742 359.193 109.88 356.323 110.027C350.583 110.32 342.988 110.645 334.922 110.933C315.379 111.629 303.476 112.432 295.993 113.953C292.261 114.712 289.714 115.634 287.895 116.755C286.106 117.857 284.976 119.179 284.118 120.836C283.726 121.596 283.467 122.132 283.313 122.556C283.163 122.972 283.147 123.189 283.162 123.324C283.176 123.445 283.226 123.611 283.434 123.9C283.656 124.208 284 124.58 284.538 125.118C284.798 125.377 285.005 125.592 285.18 125.774C285.535 126.141 285.757 126.371 286.013 126.56C286.274 126.751 286.551 126.879 287.188 126.905C287.894 126.933 288.941 126.831 290.697 126.569C291.927 126.386 293.454 126.133 295.393 125.811C296.196 125.678 297.07 125.533 298.022 125.376C311.217 123.208 326.322 123.175 335.52 125.347C339.435 126.271 348.185 129.367 354.991 132.22L354.991 132.22C362.901 135.536 367.498 137.307 370.553 137.98C372.06 138.311 373.113 138.357 373.956 138.223C374.784 138.092 375.492 137.775 376.296 137.248L376.296 137.248C378.095 136.07 379.364 134.004 380.068 131.373C380.77 128.749 380.878 125.664 380.435 122.627C379.993 119.589 379.01 116.666 377.59 114.357C376.165 112.041 374.361 110.432 372.305 109.825Z",
    fill: "url(#paint11_linear_4903_18601)",
    stroke: "url(#paint12_linear_4903_18601)",
    strokeWidth: 2.31528
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M414.292 1.87221L414.292 1.87221C410.467 1.64512 402.97 1.7201 395.764 1.96967C388.516 2.2207 381.812 2.64078 379.496 3.06603C373.997 4.07595 369.618 6.93817 367.459 10.6186C366.134 12.8805 365.555 16.1108 365.256 26.106C365.044 33.1792 364.748 37.5599 363.326 42.5079C361.92 47.3999 359.428 52.7913 354.984 61.9474L354.984 61.9475C347.351 77.6729 343.925 94.7171 343.742 118.435C343.691 125.033 344.002 129.182 344.881 132.099C345.717 134.873 347.078 136.571 349.4 138.215C352.583 140.469 355.989 141.756 362.436 142.14C368.98 142.531 378.501 141.985 393.84 140.624C405.364 139.602 411.973 138.823 416.319 137.641C418.456 137.06 419.985 136.397 421.249 135.593C422.514 134.79 423.585 133.801 424.768 132.479L426.062 133.638L424.768 132.479C427.118 129.856 428.514 127.415 429.262 124.269C430.025 121.054 430.135 117.004 429.71 111.112C428.575 95.4059 428.003 87.0942 428.1 81.7303C428.199 76.2021 429.016 73.6798 430.551 69.6028L430.551 69.6024C432.109 65.47 435.788 56.7046 438.733 50.1068L438.734 50.1066C443.734 38.9084 446.388 31.3592 447.08 25.5297C447.754 19.8542 446.569 15.7976 443.664 11.4999C439.591 5.47642 433.133 2.98947 414.292 1.87221Z",
    fill: "url(#paint13_linear_4903_18601)",
    stroke: "url(#paint14_linear_4903_18601)",
    strokeWidth: 3.47292
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.721 116.013C238.605 116.901 245.898 119.309 250.928 121.363C255.958 123.417 265.023 127.007 271.071 129.339C280.822 133.1 282.069 133.903 282.069 136.421C282.069 138.616 280.886 139.872 276.86 141.954C269.277 145.875 260.896 144.902 238.069 137.451C219.603 131.423 216.098 130.873 201.694 131.742C197.54 131.993 196.161 131.553 194.444 129.432C191.649 125.98 190.571 121.408 192.011 119.112C194.121 115.748 224.065 113.575 234.721 116.013Z",
    fill: "url(#paint15_linear_4903_18601)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M278.305 109.825L278.304 109.824C277.34 109.54 276.204 109.335 275.16 109.241C274.084 109.144 273.233 109.175 272.788 109.285C272.529 109.349 272.075 109.401 271.556 109.449C270.999 109.502 270.265 109.559 269.378 109.62C267.603 109.742 265.193 109.88 262.323 110.027C256.583 110.32 248.988 110.645 240.922 110.933C221.379 111.629 209.476 112.432 201.993 113.953C198.261 114.712 195.714 115.634 193.895 116.755C192.106 117.857 190.976 119.179 190.118 120.836C189.726 121.596 189.467 122.132 189.313 122.556C189.163 122.972 189.147 123.189 189.162 123.324C189.176 123.445 189.226 123.611 189.434 123.9C189.656 124.208 190 124.58 190.538 125.118C190.798 125.377 191.005 125.592 191.18 125.774C191.535 126.141 191.757 126.371 192.013 126.56C192.274 126.751 192.551 126.879 193.188 126.905C193.894 126.933 194.941 126.831 196.697 126.569C197.927 126.386 199.454 126.133 201.393 125.811C202.196 125.678 203.07 125.533 204.022 125.376C217.217 123.208 232.322 123.175 241.52 125.347C245.435 126.271 254.185 129.367 260.991 132.22L260.991 132.22C268.901 135.536 273.498 137.307 276.553 137.98C278.06 138.311 279.113 138.357 279.956 138.223C280.784 138.092 281.492 137.775 282.296 137.248L282.296 137.248C284.095 136.07 285.364 134.004 286.068 131.373C286.77 128.749 286.878 125.664 286.435 122.627C285.993 119.589 285.01 116.666 283.59 114.357C282.165 112.041 280.361 110.432 278.305 109.825Z",
    fill: "url(#paint16_linear_4903_18601)",
    stroke: "url(#paint17_linear_4903_18601)",
    strokeWidth: 2.31528
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M320.292 1.87221L320.292 1.87221C316.467 1.64512 308.97 1.7201 301.764 1.96967C294.516 2.2207 287.812 2.64078 285.496 3.06603C279.997 4.07595 275.618 6.93817 273.459 10.6186C272.134 12.8805 271.555 16.1108 271.256 26.106C271.044 33.1792 270.748 37.5599 269.326 42.5079C267.92 47.3999 265.428 52.7913 260.984 61.9474L260.984 61.9475C253.351 77.6729 249.925 94.7171 249.742 118.435C249.691 125.033 250.002 129.182 250.881 132.099C251.717 134.873 253.078 136.571 255.4 138.215C258.583 140.469 261.989 141.756 268.436 142.14C274.98 142.531 284.501 141.985 299.84 140.624C311.364 139.602 317.973 138.823 322.319 137.641C324.456 137.06 325.985 136.397 327.249 135.593C328.514 134.79 329.585 133.801 330.768 132.479L332.062 133.638L330.768 132.479C333.118 129.856 334.514 127.415 335.262 124.269C336.025 121.054 336.135 117.004 335.71 111.112C334.575 95.4059 334.003 87.0942 334.1 81.7303C334.199 76.2021 335.016 73.6798 336.551 69.6028L336.551 69.6024C338.109 65.47 341.788 56.7046 344.733 50.1068L344.734 50.1066C349.734 38.9084 352.388 31.3592 353.08 25.5297C353.754 19.8542 352.569 15.7976 349.664 11.4999C345.591 5.47642 339.133 2.98947 320.292 1.87221Z",
    fill: "url(#paint18_linear_4903_18601)",
    stroke: "url(#paint19_linear_4903_18601)",
    strokeWidth: 3.47292
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.721 116.013C144.605 116.901 151.898 119.309 156.928 121.363C161.958 123.417 171.023 127.007 177.071 129.339C186.822 133.1 188.069 133.903 188.069 136.421C188.069 138.616 186.886 139.872 182.86 141.954C175.277 145.875 166.896 144.902 144.069 137.451C125.603 131.423 122.098 130.873 107.694 131.742C103.54 131.993 102.161 131.553 100.444 129.432C97.649 125.98 96.5712 121.408 98.0113 119.112C100.121 115.748 130.065 113.575 140.721 116.013Z",
    fill: "url(#paint20_linear_4903_18601)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.305 109.825L184.304 109.824C183.34 109.54 182.204 109.335 181.16 109.241C180.084 109.144 179.233 109.175 178.788 109.285C178.529 109.349 178.075 109.401 177.556 109.449C176.999 109.502 176.265 109.559 175.378 109.62C173.603 109.742 171.193 109.88 168.323 110.027C162.583 110.32 154.988 110.645 146.922 110.933C127.379 111.629 115.476 112.432 107.993 113.953C104.261 114.712 101.714 115.634 99.8947 116.755C98.1058 117.857 96.9755 119.179 96.1182 120.836C95.7255 121.596 95.4671 122.132 95.3133 122.556C95.1625 122.972 95.1472 123.189 95.1622 123.324C95.1757 123.445 95.226 123.611 95.4343 123.9C95.6558 124.208 96.0005 124.58 96.5382 125.118C96.7977 125.377 97.005 125.592 97.1802 125.774C97.5346 126.141 97.7573 126.371 98.0131 126.56C98.2736 126.751 98.5511 126.879 99.1879 126.905C99.8941 126.933 100.941 126.831 102.697 126.569C103.927 126.386 105.454 126.133 107.393 125.811C108.196 125.678 109.07 125.533 110.022 125.376C123.217 123.208 138.322 123.175 147.52 125.347C151.435 126.271 160.185 129.367 166.991 132.22L166.991 132.22C174.901 135.536 179.498 137.307 182.553 137.98C184.06 138.311 185.113 138.357 185.956 138.223C186.784 138.092 187.492 137.775 188.296 137.248L188.296 137.248C190.095 136.07 191.364 134.004 192.068 131.373C192.77 128.749 192.878 125.664 192.435 122.627C191.993 119.589 191.01 116.666 189.59 114.357C188.165 112.041 186.361 110.432 184.305 109.825Z",
    fill: "url(#paint21_linear_4903_18601)",
    stroke: "url(#paint22_linear_4903_18601)",
    strokeWidth: 2.31528
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.292 1.87221L226.292 1.87221C222.467 1.64512 214.97 1.7201 207.764 1.96967C200.516 2.2207 193.812 2.64078 191.496 3.06603C185.997 4.07595 181.618 6.93817 179.459 10.6186C178.134 12.8805 177.555 16.1108 177.256 26.106C177.044 33.1792 176.748 37.5599 175.326 42.5079C173.92 47.3999 171.428 52.7913 166.984 61.9474L166.984 61.9475C159.351 77.6729 155.925 94.7171 155.742 118.435C155.691 125.033 156.002 129.182 156.881 132.099C157.717 134.873 159.078 136.571 161.4 138.215C164.583 140.469 167.989 141.756 174.436 142.14C180.98 142.531 190.501 141.985 205.84 140.624C217.364 139.602 223.973 138.823 228.319 137.641C230.456 137.06 231.985 136.397 233.249 135.593C234.514 134.79 235.585 133.801 236.768 132.479L238.062 133.638L236.768 132.479C239.118 129.856 240.514 127.415 241.262 124.269C242.025 121.054 242.135 117.004 241.71 111.112C240.575 95.4059 240.003 87.0942 240.1 81.7303C240.199 76.2021 241.016 73.6798 242.551 69.6028L242.551 69.6024C244.109 65.47 247.788 56.7046 250.733 50.1068L250.734 50.1066C255.734 38.9084 258.388 31.3592 259.08 25.5297C259.754 19.8542 258.569 15.7976 255.664 11.4999C251.591 5.47642 245.133 2.98947 226.292 1.87221Z",
    fill: "url(#paint23_linear_4903_18601)",
    stroke: "url(#paint24_linear_4903_18601)",
    strokeWidth: 3.47292
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7214 116.013C50.6053 116.901 57.8984 119.309 62.9284 121.363C67.9583 123.417 77.0226 127.007 83.0713 129.339C92.8221 133.1 94.0689 133.903 94.0689 136.421C94.0689 138.616 92.8858 139.872 88.8595 141.954C81.277 145.875 72.8956 144.902 50.0693 137.451C31.6026 131.423 28.0984 130.873 13.6939 131.742C9.54025 131.993 8.1615 131.553 6.44356 129.432C3.64901 125.98 2.57125 121.408 4.01135 119.112C6.12057 115.748 36.0653 113.575 46.7214 116.013Z",
    fill: "url(#paint25_linear_4903_18601)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3045 109.825L90.3044 109.824C89.3405 109.54 88.2044 109.335 87.16 109.241C86.0844 109.144 85.233 109.175 84.7876 109.285C84.5286 109.349 84.0746 109.401 83.5557 109.449C82.9992 109.502 82.2648 109.559 81.378 109.62C79.6029 109.742 77.1929 109.88 74.3234 110.027C68.5833 110.32 60.988 110.645 52.9217 110.933C33.379 111.629 21.4761 112.432 13.9926 113.953C10.2608 114.712 7.71402 115.634 5.89472 116.755C4.10577 117.857 2.97554 119.179 2.11825 120.836C1.72552 121.596 1.46708 122.132 1.31332 122.556C1.16255 122.972 1.14719 123.189 1.16219 123.324C1.17572 123.445 1.22601 123.611 1.43428 123.9C1.65582 124.208 2.00051 124.58 2.53824 125.118C2.79769 125.377 3.00506 125.592 3.18024 125.774C3.53465 126.141 3.75733 126.371 4.01307 126.56C4.27357 126.751 4.55115 126.879 5.18795 126.905C5.89415 126.933 6.94148 126.831 8.69738 126.569C9.92689 126.386 11.4541 126.133 13.393 125.811C14.196 125.678 15.0697 125.533 16.0222 125.376C29.217 123.208 44.3224 123.175 53.5205 125.347C57.435 126.271 66.1849 129.367 72.9905 132.22L72.9905 132.22C80.9007 135.536 85.498 137.307 88.5535 137.98C90.0597 138.311 91.1132 138.357 91.9565 138.223C92.7839 138.092 93.4921 137.775 94.2962 137.248L94.2962 137.248C96.0946 136.07 97.3645 134.004 98.0683 131.373C98.77 128.749 98.8779 125.664 98.4355 122.627C97.993 119.589 97.0097 116.666 95.5896 114.357C94.1653 112.041 92.3611 110.432 90.3045 109.825Z",
    fill: "url(#paint26_linear_4903_18601)",
    stroke: "url(#paint27_linear_4903_18601)",
    strokeWidth: 2.31528
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.292 1.87221L132.292 1.87221C128.467 1.64512 120.97 1.7201 113.764 1.96967C106.516 2.2207 99.8121 2.64078 97.4959 3.06603C91.9965 4.07595 87.6182 6.93817 85.4594 10.6186C84.134 12.8805 83.555 16.1108 83.2558 26.106C83.0444 33.1792 82.7482 37.5599 81.3261 42.5079C79.9201 47.3999 77.4284 52.7913 72.9843 61.9474L72.9843 61.9475C65.3506 77.6729 61.9249 94.7171 61.7421 118.435C61.6914 125.033 62.0021 129.182 62.8811 132.099C63.717 134.873 65.0782 136.571 67.4 138.215C70.5833 140.469 73.989 141.756 80.4362 142.14C86.98 142.531 96.5005 141.985 111.84 140.624C123.364 139.602 129.973 138.823 134.319 137.641C136.456 137.06 137.985 136.397 139.249 135.593C140.514 134.79 141.585 133.801 142.768 132.479L144.062 133.638L142.768 132.479C145.118 129.856 146.514 127.415 147.262 124.269C148.025 121.054 148.135 117.004 147.71 111.112C146.575 95.4059 146.003 87.0942 146.1 81.7303C146.199 76.2021 147.016 73.6798 148.551 69.6028L148.551 69.6024C150.109 65.47 153.788 56.7046 156.733 50.1068L156.734 50.1066C161.734 38.9084 164.388 31.3592 165.08 25.5297C165.754 19.8542 164.569 15.7976 161.664 11.4999C157.591 5.47642 151.133 2.98947 132.292 1.87221Z",
    fill: "url(#paint28_linear_4903_18601)",
    stroke: "url(#paint29_linear_4903_18601)",
    strokeWidth: 3.47292
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4903_18601",
    x1: 540.18,
    y1: 137.545,
    x2: 474.773,
    y2: 136.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4903_18601",
    x1: 488.665,
    y1: 103.395,
    x2: 556.387,
    y2: 121.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24A45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4903_18601",
    x1: 488.665,
    y1: 110.919,
    x2: 491.559,
    y2: 120.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26F6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4903_18601",
    x1: 530.749,
    y1: 80.9029,
    x2: 589.272,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4903_18601",
    x1: 492.861,
    y1: 49.5324,
    x2: 556.853,
    y2: 99.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999324,
    stopColor: "#FD8787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4903_18601",
    x1: 445.18,
    y1: 137.545,
    x2: 379.773,
    y2: 136.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4903_18601",
    x1: 393.665,
    y1: 103.395,
    x2: 461.387,
    y2: 121.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24A45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4903_18601",
    x1: 393.665,
    y1: 110.919,
    x2: 396.559,
    y2: 120.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26F6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4903_18601",
    x1: 435.749,
    y1: 80.9029,
    x2: 494.272,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4903_18601",
    x1: 397.861,
    y1: 49.5324,
    x2: 461.853,
    y2: 99.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999324,
    stopColor: "#FD8787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4903_18601",
    x1: 351.18,
    y1: 137.545,
    x2: 285.773,
    y2: 136.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4903_18601",
    x1: 299.665,
    y1: 103.395,
    x2: 367.387,
    y2: 121.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24A45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4903_18601",
    x1: 299.665,
    y1: 110.919,
    x2: 302.559,
    y2: 120.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26F6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4903_18601",
    x1: 341.749,
    y1: 80.9029,
    x2: 400.272,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4903_18601",
    x1: 303.861,
    y1: 49.5324,
    x2: 367.853,
    y2: 99.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999324,
    stopColor: "#FD8787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4903_18601",
    x1: 257.18,
    y1: 137.545,
    x2: 191.773,
    y2: 136.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4903_18601",
    x1: 205.665,
    y1: 103.395,
    x2: 273.387,
    y2: 121.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24A45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4903_18601",
    x1: 205.665,
    y1: 110.919,
    x2: 208.559,
    y2: 120.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26F6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4903_18601",
    x1: 247.749,
    y1: 80.9029,
    x2: 306.272,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4903_18601",
    x1: 209.861,
    y1: 49.5324,
    x2: 273.853,
    y2: 99.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999324,
    stopColor: "#FD8787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4903_18601",
    x1: 163.18,
    y1: 137.545,
    x2: 97.7729,
    y2: 136.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4903_18601",
    x1: 111.665,
    y1: 103.395,
    x2: 179.387,
    y2: 121.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24A45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4903_18601",
    x1: 111.665,
    y1: 110.919,
    x2: 114.559,
    y2: 120.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26F6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4903_18601",
    x1: 153.749,
    y1: 80.9029,
    x2: 212.272,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4903_18601",
    x1: 115.861,
    y1: 49.5324,
    x2: 179.853,
    y2: 99.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999324,
    stopColor: "#FD8787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4903_18601",
    x1: 69.1796,
    y1: 137.545,
    x2: 3.77287,
    y2: 136.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4903_18601",
    x1: 17.6646,
    y1: 103.395,
    x2: 85.3866,
    y2: 121.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24A45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4903_18601",
    x1: 17.6646,
    y1: 110.919,
    x2: 20.5587,
    y2: 120.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E26F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26F6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4903_18601",
    x1: 59.7488,
    y1: 80.9029,
    x2: 118.272,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#682933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4903_18601",
    x1: 21.8611,
    y1: 49.5324,
    x2: 85.8528,
    y2: 99.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999324,
    stopColor: "#FD8787",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairs);
export default __webpack_public_path__ + "static/media/chairs.57c8a85247270bec89f422ea3d184618.svg";
export { ForwardRef as ReactComponent };